import {
  BuildBundleRechargeRequestProps,
  BundleRechargeRequestProps,
  RechargeAirtimeProps,
  RechargeWalletProps,
} from "_interfaces/http-requests/recharge";
import {
  CUSTOMER_BY_PHONE,
  RECHARGE_AIRTIME,
  RECHARGE_BUILD_BUNDLE,
  RECHARGE_BUNDLE,
  RECHARGE_FULFILL,
  RECHARGE_WALLET,
} from "config/endpoint";
import { HTTP } from "functions/http";

export const CustomerByPhone = (phoneNumber: string) => {
  return HTTP({
    Method: "GET",
    Url: CUSTOMER_BY_PHONE(phoneNumber),
  });
};

export const RechargeAirtime = ({ DATA }: RechargeAirtimeProps) => {
  return HTTP({
    Method: "POST",
    Url: RECHARGE_AIRTIME,
    Data: DATA,
    linkCodeFlow: "recharge",
  });
};

export const RechargeWallet = ({ DATA }: RechargeWalletProps) => {
  return HTTP({
    Method: "POST",
    Url: RECHARGE_WALLET,
    Data: DATA,
    linkCodeFlow: "recharge",
  });
};

export const RechargeBundle = ({ DATA }: BundleRechargeRequestProps) => {
  return HTTP({
    Method: "POST",
    Url: RECHARGE_BUNDLE,
    Data: DATA,
    linkCodeFlow: "recharge",
  });
};

export const RechargeBuildBundle = ({
  DATA,
}: BuildBundleRechargeRequestProps) => {
  return HTTP({
    Method: "POST",
    Url: RECHARGE_BUILD_BUNDLE,
    Data: DATA,
    linkCodeFlow: "recharge",
  });
};

export const RechargeFulfill = (ID: string) => {
  return HTTP({
    Method: "POST",
    Url: RECHARGE_FULFILL(ID),
    linkCodeFlow: "recharge",
  });
};
